import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select'
import utils from '../../../../utils/validateScanner.js'
import { showMandatoryWeighingSnackbar, handleMandatoryWeighingHardBlock, isMandatoryWeighingSoftBlock, shouldShowMandatoryWeighingResultField } from '../../../../utils/mandatoryWeighingResponse.js'

export default {
  name: 'weighing-scale',
	mixins: [utils],
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      username: '',
      uasertype: '',
      portlist: [],
      WeightDetails: [],
      portName: '',
      boudrate: '9600',
      hubid: '',
      WeightType: "WMCB",
      ShipmentLength: '',
      ShipmentBreadth: '',
      ShipmentHeight: '',
      ShipmentWeight: '',
      ShipmentID: '',
      VolumetricWeight: '',
      fullSuccessMessage: false,
      displayShipmentid: '',
      Destination: '',
      ProcessCode: '',
      ZoneName: '',
      machineConfig: [],
      IsHeavyShipment: false,
      mpsType: '',
      confirmwt: false,
      confirmvolwt: false,
      ConfirmPhysicalWeight: false,
      ConfirmVolumetricWeight:false,
      inscanShipmentid:'',
      mandatoryWeighingSoftBlock: false,
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      IsObject: false,
      timeoutHandler: 0,
			inputString:'',
			manualInput:false,
      clientType : '',
      MPSQuantity:'',
			MpsGroupID:'',
			showQuentity:false,
      section:null,
      bayNo:null,
      ptlid:null,
      ServiceType: '',
      priorityflag:null,
      centerType:null,
      facilitytype:null,
      MOT:'',
      ShipmentType:'',
      shipWeight:true,
      shipmentModal:false,
			viewList:false,
			createBag:false,
			delinkShipment:false,
			confirmDelink:false,
			bagShipmentID:'',
			delinkBagShipmentID:'',
			bagSeal:'',
			basketData:{},
			bagDestinationObj:{},
			ShipmentList:[],
			ShipmentCount:0,
			bagShipmentIDError:'',
			bagSealError:'',
			delinkBagShipmentIDError:'',
			bShipInScan:false,
			bSealInScan:false,
			basketLoader:true,
			preModal:'',
      IsWeighingInfraAvailable:'',
			// FM Bagging
      handovertype:'',
      handovererrors:'',
      handoverBag:'',
      showfmlist:false,
      loadingFMList:false,
      fmPendencyList:[],
      handoverBagError: '',
      isfmbagInScan: false,
      fmbagInScanObj: {},
      fmMarkingIds: {},
      checked:[],
      supervisor: false,
      intiateFMShortage:false,
      pShipmentArr:[],
			showAdherenceModal:false,
			adherenceMsg:'',
			adherenceType:'',
			bagConfirmData:{}
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.userid = parseInt(userdetail[0].userid, 10);
    this.hubid = userdetail[0].HubId;
    this.useremail = userdetail[0].email
    this.getIPAddress();
    this.getHubDetails(this.hubid[0])
     .then(centerType => {
       this.centerType = centerType;
     })
  },
  watch: {
 centerType(newValue) {
   this.facilitytype=newValue;
 }
},
  methods: {
    displayMandatoryWeighingField(value) {
      return shouldShowMandatoryWeighingResultField(this.mandatoryWeighingSoftBlock, value);
    },
    applyMandatoryWeighingScanOutcome(data) {
      this.mandatoryWeighingSoftBlock = isMandatoryWeighingSoftBlock(data);
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    getIPAddress() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchHubMachineConfiguration?hubId=' + this.hubid[0] + '&machineType=weighingmachine',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.machineConfig = result.data.ResponseData;
            this.getPortList();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    getPortList() {
      var url = this.machineConfig[0] != undefined ? this.machineConfig[0].url : ''
      this.IsObject = false
      axios({
          method: 'GET',
          'url': 'http://localhost:8081/api/portlist'
        })
        .then(result => {
          var comArr = result.data;
          if (comArr.constructor === Object) {
            this.IsObject = true
            this.portName = comArr.comName
          } else {
            this.IsObject = false
            this.portlist = comArr.filter(res => {
              let manufacturer='';
              if(res.manufacturer)
              {
                manufacturer=res.manufacturer.toLowerCase();
              }
              if (res.manufacturer == 'FTDI' || res.manufacturer == 'Megawin_Technology_Co.__Ltd.' || manufacturer.includes('prolific') || manufacturer.includes('cadyce')) {
                return res.manufacturer
              }
            })
          }
          //this.portlist = result.data;
          //this.getWeight()
          // if (result.data.returnCode == 100) {
          //   this.portName = result.data.comName
          //   // this.getWeight()
          // } else {
          //   this.$alertify.error(result.data.returnMessage)
          // }
        }, error => {
          console.error(error)
          if (error.response == undefined) {
            this.$alertify.error('Failed to connect weighing machine')
          }
        })
    },
    getWeight(pickupExists) {
      this.input = ({
        "baudrate": this.boudrate,
        "port": this.portName,
        "machinetype": "W"
      })
      axios({
          method: 'POST',
          'url': 'http://localhost:8081/api/calWeight',
          'data': this.input
        })
        .then(result => {
          this.ShipmentWeight = result.data.weight
          this.Inscan(pickupExists);
        }, error => {
          console.error(error)
          if (error.response == undefined) {
            this.$alertify.error('Failed to fetch weight')
          }
        })
    },
    Inscan(pickupExists) {
      if (this.ShipmentID == '') {
        return false
      } else {
        console.log("valid ID");
      }
      if (this.ShipmentWeight <= 0) {
        this.$alertify.error("Shipment weight cannot be blank or zero")
        return false;
      }
      if (this.ShipmentWeight > 20) {
        this.confirmwt = true
        this.ConfirmPhysicalWeight = true
        this.$alertify.error("Shipment Weight is more than 20 KG")
      } else {
        this.confirmwt = false
      }
      this.VolumetricWeight = (this.ShipmentLength * this.ShipmentBreadth * this.ShipmentHeight) / 6000;
      if (this.VolumetricWeight > 20) {
        this.confirmvolwt = true
        this.ConfirmVolumetricWeight = true
        this.$alertify.error("Volumetric Weight is more than 20 KG")
      } else {
        this.confirmvolwt = false
      }
      // this.VolumetricWeight = (this.ShipmentLength * this.ShipmentBreadth * this.ShipmentHeight) / 6000;
      var date = new Date();
      this.isLoading = true;
      this.input = ({
        "shippingID": this.ShipmentID.toString(),
        "originHubID": this.hubid[0],
        "lastModifiedBy": this.useremail,
        "isConfirmInScan": true,
        "isConfirmVolWt": this.ConfirmVolumetricWeight,
        "isConfirmPhyWt": this.ConfirmPhysicalWeight,
        "inScanFromDevice": this.WeightType,
        "shipmentLength": Number(this.ShipmentLength),
        "shipmentBreadth": Number(this.ShipmentBreadth),
        "shipmentHeight": Number(this.ShipmentHeight),
        "physicalWeight": Number(this.ShipmentWeight),
        "latitude": null,
        "longitude": null,
        "deviceID": null,
        "deviceCapturedDate": moment(date).format('YYYY-MM-DD'),
        "statusMarkedFrom": "WEB",
        "inscanType": 2,
        "isManualEntry": this.manualInput,
        "facilitytype":this.facilitytype
      })

      if (this.userid) {
        this.input.userId = this.userid;
      }
      if (pickupExists) {
        this.input.isPickUpBasketFacility = true;
      }

      // FM Bagging
      if(this.restrictionConfig && this.restrictionConfig.isFmBaggingLoc && this.handoverBag) {
        this.input.bagNumber = this.handoverBag;
      }

      if (this.isAdherenceFalse) {
        this.input.isAdherence = false;
        this.isAdherenceFalse = false;
      }

      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'manualShipmentInScan',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (handleMandatoryWeighingHardBlock(this, result.data, 'manualShipmentInScan')) {
            this.isLoading = false;
            this.$validator.reset();
            return;
          }
          if (result.data.ResultCode == 100) {
            showMandatoryWeighingSnackbar(this, result.data);
            this.applyMandatoryWeighingScanOutcome(result.data);
            this.invalidTokenModal = false
            this.inscanShipmentid = this.ShipmentID
            this.ShipmentID = '';
            this.manualInput = false
            this.clientType = '';
            // this.ShipmentLength = '';
            // this.ShipmentBreadth = '';
            // this.ShipmentHeight = '';
            // this.VolumetricWeight = '';
            // this.ShipmentWeight = '';
            this.$validator.reset()

            this.isLoading = false;
            this.$alertify.success(result.data.ReturnMessage);
            this.showHubColorCode(this.inscanShipmentid);
			this.fmBagSealInScan();
          } else if (result.data.ResultCode == 401) {
            this.isLoading = false;
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 208) {
            this.isLoading = false;
            this.adherenceMsg = result.data.ReturnMessage;
            this.adherenceType = 'inscan';
            this.showAdherenceModal = true;
          } else {
            this.invalidTokenModal = false
            this.ShipmentID = '';
            this.manualInput = false
            this.displayShipmentid = '';
            this.inscanShipmentid = '';
            // this.ShipmentLength = '';
            // this.ShipmentBreadth = '';
            // this.ShipmentHeight = '';
            // this.VolumetricWeight = '';
            // this.ShipmentWeight = '';
            this.isLoading = false
            this.$validator.reset()
            this.fullSuccessMessage = false;

            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    showHubColorCode(ShipmentID) {
      this.MPSQuantity = '';
			this.MpsGroupID = '';
			this.showQuentity =false;
      this.MOT = '';
      this.ShipmentType = '';

      let pupStr = (this.restrictionConfig && this.restrictionConfig.pickupExists) ? `&isPickUpBasketFacility=true&userId=${this.userid}` : '';

      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getHubColourCode?shippingID=" + ShipmentID + pupStr,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            // PXB-7142 Shipment Color Code & Icon
						if(Object.keys(result.data.lossCategorization).length !=0){
							this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
						}

            // Multiple processing Center Connectivity
						this.pickUpBasketData = (this.pickUpBasketData) ? result.data.ResponseData.pickUpBasketData :[];

            this.isLoading = false;
            this.invalidTokenModal = false
            this.fullSuccessMessage = true;
            this.IsHeavyShipment = result.data.isHeavyShipment
            this.mpsType = result.data.ResponseData.mpsType
            this.displayShipmentid = result.data.ResponseData.shippingId || this.displayShipmentid;
            this.Destination = (this.pickUpBasketData) ? result.data.ResponseData.nextBagDestination : result.data.ResponseData.HubName;
            this.ProcessCode = result.data.ResponseData.ProcessCode;
            this.ZoneName = result.data.ResponseData.ZoneName;
            this.clientType = result.data.ResponseData.clientType;
            this.ServiceType = result.data.ResponseData.serviceType;
            this.section = result.data.ResponseData.sortersection;
            this.bayNo = result.data.ResponseData.bayno;
            this.priorityflag = result.data.ResponseData.fmPriorityFlag;
            this.MOT = result.data.ResponseData.MOT;
            this.ShipmentType = result.data.ResponseData.ShipmentType;
            this.ptlid = (this.section && this.section.includes('PTL') && result.data.ResponseData.ptlid) ? result.data.ResponseData.ptlid : ``;
            if(result.data.ResponseData.count){
              this.MPSQuantity = result.data.ResponseData.count;
              this.MpsGroupID = result.data.ResponseData.mpsGroupId;
              this.showQuentity =true
            }
            // this.$alertify.success(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.isLoading = false;
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.isLoading = false;
            this.fullSuccessMessage = false;
            this.IsHeavyShipment = false
            this.mpsType = ''
            this.displayShipmentid = '';
            this.manualInput = false
            this.Destination = '';
            this.ProcessCode = '';
            this.ZoneName = '';
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
          this.$alertify.error("Error at getHubColourCode API")
          console.error(error)
        })
    },
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    resetForm() {
      this.handovererrors = '';
      this.ShipmentID = '';
      this.manualInput = false
      this.WeightType = "WMCB";
      this.ShipmentLength = '';
      this.ShipmentBreadth = '';
      this.ShipmentHeight = '';
      this.VolumetricWeight = '';
      this.ShipmentWeight = '';
      this.fullSuccessMessage = false;
      this.IsHeavyShipment = false;
      this.mpsType = ''
      this.displayShipmentid = '';
      this.inscanShipmentid = '';
      this.Destination = '';
      this.ProcessCode = '';
      this.ZoneName = '';
      this.ConfirmPhysicalWeight = false
      this.ConfirmVolumetricWeight = false
      this.confirmwt = false
      this.confirmvolwt = false;
      this.showQuentity =false
			this.MPSQuantity = '';
			this.MpsGroupID = '';
       // FM Bagging
	this.handovertype = '';
        this.handovererrors = '';
        this.handoverBag = '';
        this.showfmlist = false;
        this.loadingFMList= false;
        this.fmPendencyList= [];
       this.bagSealError= '',
       this.isfmbagInScan= false;
       this.fmbagInScanObj= {};
      this.$validator.reset();
      this.showHideCodeIconInput();
    },

    // START -- PXB-6185 - Pickup Center to Multiple processing Center Connectivity //
    fetchBagShipmentList(data,type,i) {

			this.closeCreateDelinkModal();

			this.basketData = data ? data : this.basketData;
			this.basketData = Object.assign({}, this.basketData, {i:i});

			this.shipmentModal = true;
			this.basketLoader = true;
			
			if(type=='list') {	

				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'pickupCenter/getShipmentCountList?pickupHubId=' + this.hubid + '&basketBarcode=' + this.basketData.basket+'&requestType=2',
					'data': {},
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {

						this.ShipmentList = result.data.ShipmentList;
						this.ShipmentCount = result.data.ShipmentCount;

						this.viewList = true;
					}else{
						this.shipmentModal = false;
						this.$alertify.error(result.data.ReturnMessage);
						return false;
					}
				}, error => {
					this.shipmentModal = false;
					console.error(error);
				})
			}
			else if(type=='delink') this.delinkShipment = true;
			else if(type=='bag') this.createBag = true;

			this.basketLoader = false;
		},

		delinkBagShipment(i) {

			if (!this.delinkBagShipmentID) {
				this.delinkBagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.delinkBagShipmentIDError = '';
			this.basketLoader = true;

			this.input = ({
				"shippingId": this.delinkBagShipmentID.toString(),
				"pickupHubId": this.hubid[0],
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.useremail
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkShipment',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.delinkBagShipmentID = '';

					this.basketData = Object.assign({}, this.basketData, {count:result.data.RemainingLinkedCount});
					this.pickUpBasketData[i].count = result.data.RemainingLinkedCount;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		takeAction(i) {
			if(this.preModal=='delink') {
				// Delink All shipment
				this.delinkAllBagShipment(i);
			} else {
				// Close Bag Modal
				this.closeCreateDelinkModal();
			}
		},

		delinkAllBagShipment(i) {
			this.basketLoader = true;

			this.input = ({
				"pickupHubId": this.hubid[0],
				"basketBarcode": this.basketData.basket,
				"modifiedBy": this.useremail
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/delinkAllShipments',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.basketData = Object.assign({}, this.basketData, {count:0});
					this.pickUpBasketData[i].count = 0;

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagShipment() {
			if (!this.bagShipmentID) {
				this.bagShipmentIDError = 'The Shipping ID field is required.'; return;
			}
			this.bagShipmentIDError = '';

			this.bShipInScan = false;
			this.basketLoader = false;

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanShipmentForBagClose?pickupHubId=' + this.hubid + '&basketBarcode=' + 
				this.basketData.basket+'&shippingId=' + this.bagShipmentID.toString()+'&createdBy=' + this.useremail,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bShipInScan = true;
					this.bagShipmentID = '';
					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		scanBagSeal() {
			if (!this.bagSeal) {
				this.bagSealError = 'Seal Number field is required.'; return;
			}
			this.bagSealError = '';

			this.bSealInScan = false;
			this.basketLoader = true;
			this.bagDestinationObj={};

			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'pickupCenter/scanBagSealApi?pickupHubId='+this.hubid+'&basketBarcode='+ 
				this.basketData.basket+'&bagDestinationHubName='+this.basketData.nextbagdestination+'&bagSealNo='+this.bagSeal+'&bagType=surfacebag'+
				'&createdBy=' + this.useremail+'&userId=' + this.userid,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.bSealInScan = true;
					
					this.bagDestinationObj = {
						"bagDestinationHubId": result.data.ResponseData.destinationHubId,
						"bagDestinationHubName": result.data.ResponseData.destinationHubName,
						"groupId": result.data.ResponseData.groupId
					}

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {
				this.basketLoader = false;
				console.error(error);
			})
		},

		closeBag() {
			this.basketLoader = true;
			
			this.input = ({
				"pickupHubId": Number(this.hubid[0]),
				"pickupHubName": this.hubname,
				"basketBarcode": this.basketData.basket,
				"bagSealNo": this.bagSeal,
				"bagDestinationHubId": this.bagDestinationObj.bagDestinationHubId,
				"bagDestinationHubName": this.bagDestinationObj.bagDestinationHubName,
				"groupId": this.bagDestinationObj.groupId,
				"bagType": 'surfacebag',
				"createdBy": this.useremail,
				"userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pickupCenter/bagCloseApi',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.pickUpBasketData[this.basketData.i].count = 0;

					this.basketData = {};
					this.closeCreateDelinkModal();

					this.$alertify.success(result.data.ReturnMessage);
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.basketLoader = false;
			}, error => {

				this.basketLoader = false;
				console.error(error);
			})
		},

		closeCreateDelinkModal() {
			this.shipmentModal = false;
			this.viewList = false;
			this.createBag = false;
			this.delinkShipment = false;
			this.confirmDelink = false;

			this.resetBasketModule();

			this.ShipmentList = [];
			this.ShipmentCount = 0;
		},

		resetBasketModule() {
			this.bagShipmentID = '';
			this.bagShipmentIDError = '';
			this.bagSeal = '';
			this.bagSealError = '';
			this.delinkBagShipmentID = '';
			this.delinkBagShipmentIDError = '';
			this.bagDestinationObj={};
			this.bShipInScan = false;
			this.bSealInScan = false;
			this.basketLoader = false;
		},

    // FM Bagging
		fmBagSealInScan() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

      // Match role for SUpervisor
			//this.supervisor = this.validateUserRole(this.roleconfig.sup_roles_fmb_shortage);
            
			this.supervisor= false;
			this.handovererrors = '';
			this.handoverBagError = '';
			this.isfmbagInScan = false;

			this.isLoading = true;
			this.fmbagInScanObj={};

			this.input = ({
				"hubId": this.hubid[0],
				"bagSealNumber": this.handoverBag,
        "eventName": "FmBagValidate",
        "userId": this.userid
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/hubInScanFMBag',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {

					this.isfmbagInScan = true;
					this.fmbagInScanObj = result.data.ResponseData;

					this.$alertify.success(result.data.ReturnMessage);
				}else if(result.data.ResultCode == 104){
					this.adherenceMsg = result.data.ReturnMessage;
					this.adherenceType = 'bag';
					this.bagConfirmData = result.data.ResponseData;
					this.showAdherenceModal = true;
				}else{
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				this.$alertify.error(result.data.ReturnMessage);
			})
		},

		completeHubInScan() {
			if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.isLoading = true;

			this.input = ({
				"hubId": this.hubid[0],
				"userId": this.userid,
				"bagSealNumbers": this.handoverBag,
				"eventName": "CompleteHubInScan",
				"source": "WEB"
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/completeHubInScan',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
				this.isLoading = false;
			}, error => {
				this.isLoading = false;
				this.$alertify.error(result.data.ReturnMessage);
			})
		},

		confirmAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.isfmbagInScan = true;
				this.fmbagInScanObj = this.bagConfirmData;
				this.handoverBag = this.fmbagInScanObj.bagSealNumber ;
				return;
			}
			this.isAdherenceFalse = true;
			this.Inscan(this.restrictionConfig && this.restrictionConfig.pickupExists ? this.restrictionConfig.pickupExists : null);
		},

		cancelAdherence() {
			this.showAdherenceModal = false;
			if (this.adherenceType === 'bag') {
				this.bagConfirmData = {};
			}
		},

		clearhandoverError(){
			if (this.handovertype) {
				this.handovererrors = '';
				this.handoverBag = '';
				this.fmbagInScanObj = {};

				this.isfmbagInScan = (this.handovertype == 'shipment') ? true : (this.handovertype == 'bag') ? false : this.isfmbagInScan;
			}
		},

		openFMShipmentPendencyList() {
			if (this.handovertype == '') {
				this.handovererrors = 'The Scan Type field is required.'; return;
			} else if (!this.handoverBag) {
				this.handoverBagError = 'Bag Number field is required.'; return;
			}

			this.handovererrors = '';
			this.handoverBagError = '';
			this.showfmlist = true;

			this.getFMBagPendencyInscan();
		},

		getFMBagPendencyInscan(){

			this.loadingFMList = true;
			this.fmPendencyList = [];

			this.input = ({
				"hubId": this.hubid[0],
				"bagSealNumber": this.handoverBag
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'fmBagging/getFMBagShipmentList',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					let responseData = result.data.ResponseData;
					if (responseData && responseData.shipments) {
						responseData.pendingshipments = responseData.shipments;
					}
					this.fmPendencyList = responseData;
					this.showfmlist=true;
					this.$alertify.success(result.data.ReturnMessage)
				}else{
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.loadingFMList=false;
			}, error => {
				this.$alertify.error(result.data.ReturnMessage);
				this.loadingFMList=false;
			})
		},

		markFMShortage(data) {
			if(data) {
				this.$set(this.fmMarkingIds, data.shippingId, true);
			}

			this.loadingFMList = true;

			let payload = {
				hubId: this.hubid[0],
				shipmentIds: (this.pShipmentArr.length) ? this.pShipmentArr : [data.shippingId],
				userId: this.userid,
				createdBy: this.useremail,
				isSupervisor: this.supervisor,
        eventName: "RaiseShortageRequest"
			};

			axios.post(`${apiUrl.api_url_hubops}fmBagging/initiateORMarkFMShortage`, 
				payload, {
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
				}}
			).then(res => {
				if (res.data.ResultCode !== 100) this.$alertify.error(res.data.ReturnMessage || "Already Marked", "error");
				else {
					this.$alertify.success(res.data.ReturnMessage, "success");
					if(data) {
						data.isMarked = true;
					}
					this.getFMBagPendencyInscan();
					this.pShipmentArr = [];
				}

				this.loadingFMList = false;
				this.intiateFMShortage = false;
			}).catch(err => this.$alertify.error(err.message, "error"))
			.finally(() => {
				if(data) {
					this.$set(this.fmMarkingIds, data.shippingId, false);
				}
			});
		},

		closeFMModal() {
			this.intiateFMShortage = false;
			this.showfmlist = true;
		},

		resethandovertype(){
			this.handovertype = '',
			this.handovererrors = '',
			this.handoverBag = '',
			this.fmbagInScanObj = {};
			this.$validator.reset()
            this.fullSuccessMessage = false;
			this.resetForm();
		},

		isfmMarked(shippingId) {
			let fmShip = this.fmPendencyList.pendingshipments.find(b => b.shippingId == shippingId);
			return fmShip && fmShip.isMarked;
		},

		updateCheckDest(event){
			this.checked[event.target.id] = event.target.checked;

			if(event.target.checked==false){
				this.pShipmentArr = this.pShipmentArr.filter(el => el != event.target.id)

			}else{
				this.pShipmentArr.indexOf(event.target.id) === -1 ? this.pShipmentArr.push(event.target.id):'';
			}
		}
    // END
  }
}



// WEBPACK FOOTER //
// ./src/views/components/HubInscan/WeighingScale/WeighingScale.js